var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_data"},[(_vm.dtype !='')?_c('p',[_vm._v("No "+_vm._s(_vm.dtype)+" were found.")]):_vm._e(),(_vm.dtype =='')?_c('p',[_vm._v("No result were found.")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }